export default "__VITE_ASSET__0fe3331b__"